import { Outlet, useLocation } from 'react-router';
import Header from './Header';
import { OfflineBanner } from '../common/OfflineBanner';
import { useAuth } from '../../hooks/useAuth';
import { useBootstrapInitialCart } from '../../hooks/useCartActions';
import { useSyncUserPreferences } from '../../hooks/useSyncUserPreferences';

const Layout = () => {
  const { pathname } = useLocation();
  const isHome = pathname === '/';
  const { isLoggedIn } = useAuth();
  useBootstrapInitialCart(isLoggedIn);
  useSyncUserPreferences();

  return (
    <div className="min-h-screen overflow-x-hidden bg-gray-50 dark:bg-gray-950 text-gray-900 dark:text-gray-100 transition-colors">
      <Header />
      <OfflineBanner />
      <main className="pt-16">
        {isHome ? (
          <Outlet />
        ) : (
          <div className="mx-auto px-4 py-6">
            <Outlet />
          </div>
        )}
      </main>
    </div>
  );
};

export default Layout;
